module.exports = __webpack_public_path__ + "img/free.adf1b891.jpg";